import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronRight, ChevronDown } from 'lucide-react';

interface RowExpanderProps {
  isExpanded: boolean;
  isExpanding: boolean;
  hasChildren: boolean;
  onClick: () => void;
}

/**
 * Component to handle row expansion/collapse with animated chevron
 */
export const RowExpander: React.FC<RowExpanderProps> = ({
  isExpanded,
  isExpanding,
  hasChildren,
  onClick,
}) => {
  if (!hasChildren) {
    return <div className="w-6 h-6" />;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className={`h-6 w-6 p-0 ${isExpanding ? 'opacity-50 cursor-not-allowed' : ''}`}
      disabled={isExpanding}
      onClick={onClick}
    >
      {isExpanding ? (
        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-500"></div>
      ) : isExpanded ? (
        <ChevronDown className="h-4 w-4 text-gray-500" />
      ) : (
        <ChevronRight className="h-4 w-4 text-gray-500" />
      )}
    </Button>
  );
};
